import { render } from "./PlanillasBorradas.vue?vue&type=template&id=ed32e248&scoped=true"
import script from "./PlanillasBorradas.vue?vue&type=script&lang=js"
export * from "./PlanillasBorradas.vue?vue&type=script&lang=js"

import "./PlanillasBorradas.vue?vue&type=style&index=0&id=ed32e248&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed32e248"]])

export default __exports__